import React from "react";
import HTabeleDetailsProduct from "./HTabeleDetailsProduct";
import TbodyDetailsProduct from "./TbodyDetailsProduct";

export default function TabeleDetailsProduct({
  data,
  tableRef,
  IdName,
  customClass,
  setinvoices,
  orders,
}) {
  return (
    <>
      <table
        id={IdName}
        ref={tableRef}
        className="table table-hover  table-striped    "
      >
        <HTabeleDetailsProduct customClass={customClass} orders={orders} />
        <TbodyDetailsProduct
          orders={orders}
          data={data}
          setinvoices={setinvoices}
        />
      </table>
    </>
  );
}
